import { type FormEvent, useState } from "react";
import { EnquiryDialog } from "../contact/EnquiryDialog";

type RequestFields = {
  requirement: string;
  specification: string;
  quantity: string;
  destination: string;
};

const emptyRequest: RequestFields = {
  requirement: "",
  specification: "",
  quantity: "",
  destination: "",
};

export function Hero() {
  const [fields, setFields] = useState<RequestFields>(emptyRequest);
  const [invalidFields, setInvalidFields] = useState<(keyof RequestFields)[]>([]);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  const updateField = (field: keyof RequestFields, value: string) => {
    setFields((current) => ({ ...current, [field]: value }));
    setInvalidFields((current) => current.filter((item) => item !== field));
    setMessage("");
  };

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const missing = (Object.keys(fields) as (keyof RequestFields)[]).filter((field) => !fields[field].trim());

    if (missing.length) {
      setInvalidFields(missing);
      setMessage("Please complete all four fields so we can assess the request.");
      return;
    }

    setOpen(true);
  };

  return (
    <><section className="hero" aria-labelledby="hero-title">
      <div className="hero-visual" aria-hidden="true">
        <img src="/assets/hero-source.png" alt="" fetchPriority="high" />
      </div>
      <div className="hero-gradient" aria-hidden="true" />
      <div className="container hero-content">
        <p className="hero-eyebrow">Sourcing &amp; Export Development from Iran</p>
        <h1 id="hero-title">Your sourcing<br />partner in <span>Iran.</span></h1>
        <p className="hero-summary">Find Iranian products, compare supplier quotations and coordinate your next purchase with a local sourcing partner.</p>
        <div className="hero-actions">
          <a className="button" href="#sourcing-request">Request Sourcing</a>
          <a className="button button--secondary" href="#products">View Available Products</a>
        </div>
      </div>
      <form id="sourcing-request" className="search-panel" onSubmit={submit} noValidate aria-label="Sourcing request starter">
        <div className="search-panel-heading">
          <h2>What do you need from Iran?</h2>
          <p>Start with your requirements. Next, add your contact details and any attachments before sending.</p>
        </div>
        <div className="search-grid">
          <label>
            <span>Product or requirement</span>
            <input
              aria-invalid={invalidFields.includes("requirement")}
              value={fields.requirement}
              onChange={(event) => updateField("requirement", event.target.value)}
              placeholder="e.g. Steel rebar"
            />
          </label>
          <label>
            <span>Specification</span>
            <input
              aria-invalid={invalidFields.includes("specification")}
              value={fields.specification}
              onChange={(event) => updateField("specification", event.target.value)}
              placeholder="Grade, size or model"
            />
          </label>
          <label>
            <span>Quantity</span>
            <input
              aria-invalid={invalidFields.includes("quantity")}
              value={fields.quantity}
              onChange={(event) => updateField("quantity", event.target.value)}
              placeholder="e.g. 25 tonnes"
            />
          </label>
          <label>
            <span>Destination country</span>
            <input
              aria-invalid={invalidFields.includes("destination")}
              value={fields.destination}
              onChange={(event) => updateField("destination", event.target.value)}
              placeholder="Destination country"
            />
          </label>
          <button className="button search-button" type="submit">Continue Enquiry</button>
        </div>
        <p className={`search-status ${invalidFields.length ? "is-error" : ""}`} role="status">{message}</p>
      </form>
    </section><EnquiryDialog open={open} onClose={() => setOpen(false)} kind="rfq" title="Complete your sourcing enquiry" initialValues={fields} /></>
  );
}
